<template>
  <div v-if="isWx && isShowGuide" class="bus-guide">
    <img
      src="../../../assets/img-v2/ic_service.png"
      class="icon"
      @click="onGuide"
    />
  </div>
</template>

<script>
import { isWX } from "@/utils";
import { mapMutations } from "vuex";

export default {
  name: "BusGuide",
  props: {
    ticketConfig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isWx: isWX(),
    };
  },
  computed: {
    isShowGuide() {
      const { isShowGuide } = this.ticketConfig || {};
      return isShowGuide;
    },
  },
  methods: {
    ...mapMutations({
      setFitViewToUserPos: "setFitViewToUserPos",
    }),
    onLocation() {
      this.setFitViewToUserPos(true);
      setTimeout(() => {
        this.setFitViewToUserPos(false);
      });
    },
    onGuide() {
      const { guideLink } = this.ticketConfig || {};
      location.href = guideLink
        ? guideLink
        : "https://mp.weixin.qq.com/s/ZE59gNYN3KwyhzfDMPu7ZA";
    },
  },
};
</script>

<style scoped lang="scss">
.bus-guide {
  margin-left: 10px;
  .icon {
    width: 24px;
    height: 24px;
    display: block;
  }
}
</style>
